import { render, staticRenderFns } from "./ArchiveProductModal.vue?vue&type=template&id=8f356cd4&"
import script from "./ArchiveProductModal.vue?vue&type=script&lang=js&"
export * from "./ArchiveProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports